module.exports = __webpack_public_path__ + "img/index-spot.f4dfbdea.png";